export enum UserTypeId {
  WRT__User = 10,
  WRT__Manager = 20,
  CA__Admin = 30,
  CA__Owner = 40,
  Super_Admin = 50,
  WRT__Admin = 60,
  WRT__Owner = 70,
  MM__User = 110,
  MM__Manager = 120,
}
